export default __webpack_public_path__ + "static/media/blocking-task-completed.5dd8e348.svg";